<template>
  <SettingForm is-edit />
</template>

<script>
import SettingForm from '@/layouts/components/form/SettingForm.vue'

export default {
  components: { SettingForm },
}
</script>
